<template>
  <div id="sidenav-collapse-main" class="collapse navbar-collapse w-auto mt-3 h-auto">
    <ul class="navbar-nav">
      <template v-for="(module, index) in menu_modules" v-bind:key="index">
        <template v-if="module.is_link">
          <li class="nav-item">
            <sidenav-collapse :nav-text="module.module_name" :to="module.url" :expand="false"
              @click="selectOptionLink(module.url)" :isActive="selectedRoute === module.url" :openHover="openHover">
              <template #icon>
                <icon :name="module.icon" />
              </template>
            </sidenav-collapse>
          </li>
        </template>
        <template v-else>
          <li class="nav-item">
            <sidenav-collapse :nav-text="module.module_name" :to="cleanRoute(module.resources)" :expand="true"
              :secondLinks="module.resources" :isActive="activeModuleIndex === index"
              @resource-clicked="handleResourceClicked(index)" @click="CleanActive()" :openHover="openHover">
              <template #icon>
                <icon :name="module.icon" />
              </template>
            </sidenav-collapse>
          </li>
        </template>
      </template>
    </ul>
  </div>
</template>

<script>
// import $ from 'jquery';
import Icon from "@/components/Icon.vue";
import SidenavCollapse from "./SidenavCollapse.vue";
import securedWebStorage from '@/main';

export default {
  name: "SidenavList",
  inject: ['api_provider', 'urls_server'],
  components: {
    Icon,
    SidenavCollapse,
  },
  props: {
    cardBg: {
      type: String,
      default: ""
    },
    openHover: {
      type: Boolean,
    }
  },
  data() {
    return {
      id: securedWebStorage.getItem("id"),
      title: "MiGPS",
      controls: "dashboardsExamples",
      menu_modules: [],
      selectedRoute: null,
      activeModuleIndex: null,
    };
  },
  // mounted() {
  //   if (this.$store.state.isAuthenticated) {
  //     this.loadMenuFromStorage();
  //   }
  // },
  beforeMount() {
    if (this.$store.state.isAuthenticated) {
      this.getList();
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    async getList() {
      try {
        const response = await this.api_provider.post(this.urls_server.get_menu, {}, "get", null, 60000);
        this.menu_modules = response.data.menu_modules;
      } catch (error) {
        console.log("Error get_menu: ", error);
      }
    },
    // loadMenuFromStorage() {
    //   const storedMenu = securedWebStorage.getItem('menuModules');
    //   if (storedMenu) {
    //     console.log(storedMenu)
    //     this.menu_modules = storedMenu;
    //   }else{
    //     this.getList()
    //   }
    // },
    cleanRoute(route) {
      if (route.length > 0) {
        let cleanedRoute = route[0].to;

        // Verificar si la ruta comienza con '/#', si es así, quitarlo.
        if (cleanedRoute.startsWith('/#')) {
          cleanedRoute = cleanedRoute.replace('/#', '');
        }
        cleanedRoute = cleanedRoute.replace('#', '');
        return cleanedRoute;
      }
      return '#';
    },
    // Selecciona un modulo sin opciones
    selectOptionLink(option) {
      this.activeModuleIndex = null
      this.selectedRoute = option
    },
    // Selecciona un modulo con opciones
    handleResourceClicked(index) {
      this.selectedRoute = null
      this.activeModuleIndex = index
    },
    CleanActive() {
      this.selectedRoute = null
      this.activeModuleIndex = null
    }
  }
};
</script>

<style scoped>
.navbar-vertical.navbar-expand-xs .navbar-collapse {
  overflow: visible !important;
}

.navbar-nav {
  overflow: scroll;
  height: calc(100lvh - 235px);
}

.navbar-nav::-webkit-scrollbar {
  display: none;
}
</style>